import React, { useState, useEffect } from 'react';
import './Subtractions.css';

const allQuestions = [
  { question: '5X3=?', options: ['15', '12', '24', '13'], answer: '15' },
  { question: '4X1=?', options: ['3', '4', '5', '6'], answer: '4' },
  { question: '3X2=?', options: ['2','3','6','8'], answer: '6' },
  { question: '7X4=?', options: ['28', '24', '31', '41'], answer: '28' },
  { question: '9X6=?', options: ['58', '54', '38', '48'], answer: '54' },
  { question: '8X2=?', options: ['14', '15', '16', '17'], answer: '16' },
  { question: '6X1=?', options: ['4', '5', '6', '7'], answer: '6' },
  { question: '10X7=?', options: ['61', '72', '70', '74'], answer: '70' },
  { question: '2X1=?', options: ['1', '2', '3', '4'], answer: '2' },
  { question: '6X3=?', options: ['13', '14', '18', '26'], answer: '18' },
  { question: '10X3=?', options: ['27', '28', '30', '40'], answer: '30' },
  { question: '8X5=?', options: ['30', '40', '45', '56'], answer: '40' },

  { question: '7X3=?', options: ['15', '21', '24', '27'], answer: '21' },
  { question: '1X1=?', options: ['3', '4', '1', '6'], answer: '1' },
  { question: '6X2=?', options: ['12','23','16','18'], answer: '12' },
  { question: '6X4=?', options: ['28', '24', '31', '41'], answer: '24' },
  { question: '9X4=?', options: ['58', '54', '36', '48'], answer: '36' },
  { question: '9X2=?', options: ['14', '18', '16', '17'], answer: '18' },
  { question: '6X5=?', options: ['24', '30', '36', '27'], answer: '30' },
  { question: '7X7=?', options: ['61', '48', '49', '52'], answer: '49' },
  { question: '8X8=?', options: ['61', '62', '63', '64'], answer: '64' },
  { question: '5X5=?', options: ['23', '24', '25', '26'], answer: '25' },
  { question: '9X3=?', options: ['27', '28', '30', '40'], answer: '27' },
  { question: '7X5=?', options: ['30', '40', '35', '56'], answer: '35' },


];

const getRandomQuestions = (num) => {
  const shuffled = [...allQuestions].sort(() => 0.5 - Math.random());
  return shuffled.slice(0, num);
};

const Multiplications = () => {
  const [questions, setQuestions] = useState([]);
  const [currentQuestion, setCurrentQuestion] = useState(0);
  const [selectedOption, setSelectedOption] = useState('');
  const [isAnswered, setIsAnswered] = useState(false);
  const [score, setScore] = useState(0);
  const [showScore, setShowScore] = useState(false);

  useEffect(() => {
    setQuestions(getRandomQuestions(10));
  }, []);

  const handleOptionChange = (e) => {
    setSelectedOption(e.target.value);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsAnswered(true);
    if (selectedOption === questions[currentQuestion].answer) {
      setScore(score + 1);
    }
  };

  const handleNextQuestion = () => {
    const nextQuestion = currentQuestion + 1;
    if (nextQuestion < questions.length) {
      setCurrentQuestion(nextQuestion);
      setIsAnswered(false);
      setSelectedOption('');
    } else {
      setShowScore(true);
    }
  };
  const openUrl = () => {
    window.open('https://draftj.in', '_blank');
}
const clearBoard = () => {
    // setBoard([...originalBoard]);
    window.location.reload();
   };
  return (
    <div className="Apps">
      <h1>Multiplication Quiz &nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<button onClick={openUrl}>Home</button> &nbsp;&nbsp;&nbsp;&nbsp;<button onClick={clearBoard}>Start Quiz Again</button></h1>
      {showScore ? (
        <div className="score-section">
          Your score: {score} out of {questions.length}
        </div>
      ) : (
        questions.length > 0 && (
          <div className="question-section">
            <div className="question-text">
              {questions[currentQuestion].question}
            </div>
            <form onSubmit={handleSubmit}>
              {questions[currentQuestion].options.map((option, index) => (
                <div key={index}>
                  <input
                    type="radio"
                    id={`option-${index}`}
                    name="option"
                    value={option}
                    checked={selectedOption === option}
                    onChange={handleOptionChange}
                    disabled={isAnswered}
                  />
                  <label htmlFor={`option-${index}`}>{option}</label>
                </div>
              ))}
              {!isAnswered && <button type="submit">Submit</button>}
            </form>
            {isAnswered && (
              <div className="answer-section">
                {selectedOption === questions[currentQuestion].answer ? (
                  <p>Correct!</p>
                ) : (
                  <p>Wrong! The correct answer is {questions[currentQuestion].answer}.</p>
                )}
                <button onClick={handleNextQuestion}>Next Question</button>
              </div>
            )}
          </div>
        )
      )}
    </div>
  );
};

export default Multiplications;
